
export default {
  name: "CardContratoAssociados",

  props: {
    associados: {
      type: Array,
      default: () => [],
    },
    contratante_associado: Number,
  },
};
